import React, { useState, useEffect } from "react";
import Header from "./Comman/Header";
import axios from "axios";
import { User, Minus, Plus, RefreshCw, AlertCircle, ChevronUp, ChevronDown, Users } from "lucide-react";


// Convert backend → UI structure
function convertTree(oldNode) {
  if (!oldNode) return null;

  return {
    address: oldNode.name,
    team: oldNode.team ?? 0,
    fromname: oldNode.fromname,
    // ✅ ADD THESE
    Strongleg1: oldNode.Strongleg1 ?? 0,
    Strongleg2: oldNode.Strongleg2 ?? 0,
    Otherleg_Team_business: oldNode.Otherleg_Team_business ?? 0,
    team_business: oldNode.team_business,
    staking: oldNode.staking,
    children: oldNode.children?.map(convertTree) || [],
    isLoaded: oldNode.children?.length > 0
  };
}


const OrgChartNode = ({ node, level = 0, onExpand }) => {

  const [isOpen, setIsOpen] = useState(false);
  const hasChildren = Array.isArray(node.children) && node.children.length > 0;

  return (
    <div className="d-flex flex-column align-items-center">

      {/* Node Content */}
      <div
        className="d-flex flex-column align-items-center position-relative z-2"
        style={{
          margin: "0 16px 28px 16px"
        }}

      >
        <div
          className={`node-card ${isOpen ? "active" : ""}`}
          style={{
            minWidth: "180px",
            cursor: node.team > 0 ? "pointer" : "default",
          }}
          onClick={() => hasChildren && setIsOpen(!isOpen)}
        >

          <div className="tree-node">
            {/* User Header */}
            <div className="node-header">
              <div className="user-icon">
                <i className="bi bi-person"></i>
              </div>

              <div className="user-info">
                {/* USERNAME */}
                <div className="node-name">
                  {node.fromname || "N/A"}
                </div>

                {/* USER ID / ADDRESS */}
                <div className="node-sub">
                  ID: {node.address}
                </div>

                <div className="node-sub">
                  Self Business: ${node.staking}
                </div>

                <div className="user-team">
                  <Users size={12} />
                  <span>Team:</span>
                  <b>{node.team}</b>
                </div>
              </div>
            </div>

            {/* Stats */}
            {/* Team Legs Business */}
            <div className="node-legs">
              <div className="leg-box primary">
                <span className="leg-label">1st Leg</span>
                <span className="leg-value">
                  ${Number(node.Strongleg1).toLocaleString()}
                </span>
              </div>

              <div className="leg-box secondary">
                <span className="leg-label">2nd Leg</span>
                <span className="leg-value">
                  ${Number(node.Strongleg2).toLocaleString()}
                </span>
              </div>

              <div className="leg-box other">
                <span className="leg-label">Other Leg</span>
                <span className="leg-value">
                  ${Number(node.Otherleg_Team_business).toLocaleString()}
                </span>
              </div>
            </div>


          </div>



          {/* Stats */}
          <div className="node-volume">Team Business
            ${Number(node.team_business).toLocaleString()}
          </div>

          <div className="node-grid">

          </div>

          {/* Expand Button */}
          {node.team > 0 && (

            <button
              className="position-absolute rounded-circle border-0 d-flex align-items-center justify-content-center"
              style={{
                bottom: "-16px",
                left: "50%",
                width: "30px",
                height: "30px",
                color: "#ffffff",
                transform: "translateX(-50%)",
                background: isOpen
                  ? "linear-gradient(135deg, #f59e0b, #d97706)"
                  : "linear-gradient(135deg, #006fe3, #005bb5)",
                boxShadow: "0 4px 10px rgba(0, 111, 227, 0.4)",
                zIndex: 5
              }}

              onClick={async (e) => {
                e.stopPropagation();

                if (!node.isLoaded) {
                  await onExpand(node.address); // 🔥 API CALL
                }

                setIsOpen(!isOpen);
              }}
            >
              {isOpen ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
            </button>

          )}
        </div>

        {/* Vertical Line DOWN from Node */}
        {isOpen && hasChildren && (
          <div
            style={{
              height: "20px",
              width: "2px",
              background: "#94a3b8",
              marginTop: "-5px" // slightly overlap to connect
            }}
          />
        )}

      </div>

      {/* Children Container */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          opacity: isOpen ? 1 : 0,
          maxHeight: isOpen ? "10000px" : "0",
          overflow: "hidden",
          transition: "all 0.5s ease-in-out",
          paddingTop: "0px"
        }}
      >
        {isOpen && hasChildren && (
          <div className="d-flex pt-3">
            {node.children.map((child, index) => (
              <div key={index} className="d-flex flex-column align-items-center position-relative">

                {/* Horizontal Connector Lines */}
                {/* We use pseudo-style logic with divs for React simplicity */}

                {/* Left connector: visible if NOT first child */}
                <div
                  style={{
                     position: 'absolute',
                     top: 0,
                     right: '50%',
                     width: '50%',
                     height: '2px',
                     background: index === 0 ? 'transparent' : '#94a3b8'
                  }}
                />

                {/* Right connector: visible if NOT last child */}
                <div
                  style={{
                     position: 'absolute',
                     top: 0,
                     left: '50%',
                     width: '50%',
                     height: '2px',
                     background: index === node.children.length - 1 ? 'transparent' : '#94a3b8'
                  }}
                />

                {/* Vertical Line UP from child */}
                <div
                  style={{
                    height: "20px",
                    width: "2px",
                    background: "#94a3b8",
                    marginBottom: "0px"
                  }}
                />

                <OrgChartNode
                  node={child}
                  level={level + 1}
                  onExpand={onExpand}
                />

              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};


export default function Tree() {
  const [treeData, setTreeData] = useState([]);
  const [scale, setScale] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleExpand = async (username) => {
    const children = await fetchChildren(username);

    setTreeData(prev =>
      prev.map(root => attachChildren(root, username, children))
    );
  };


  const fetchChildren = async (username) => {
    const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
      method: "user",
      submethod: "getree",
      username,
      key: process.env.REACT_APP_KEY,
    });

    return res.data?.data?.children || [];
  };

  function attachChildren(node, target, newChildren) {
    if (node.address === target) {
      return {
        ...node,
        children: newChildren.map(convertTree),
        isLoaded: true
      };
    }

    return {
      ...node,
      children: node.children.map(child =>
        attachChildren(child, target, newChildren)
      )
    };
  }


  useEffect(() => {
    fetchTree();
  }, []);


  const fetchTree = async () => {
    try {
      setLoading(true);
      setError(false);

      const username = localStorage.getItem("username");

      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "getree",
        username,
        key: process.env.REACT_APP_KEY,
      });
      console.log('res tree', res.data.data);

      if (res.data.resCode === 200 && res.data.data) {
        setTreeData([convertTree(res.data.data)]);
      } else {
        // Fallback if data is weird or empty
        if (!res.data.data) throw new Error("No data");
        setTreeData([convertTree(res.data.data)]);
      }
    } catch (e) {
      console.error("Tree fetch error:", e);
      setError(true);
    } finally {
      setLoading(false);
    }
  };


  const handleRetry = () => {
    fetchTree();
  };

  return (
    <div className="body-bg">
      <Header />

      <section className="nftmax-adashboard nftmax-show">
        <div className="container-fluid px-4">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="d-flex flex-column gap-2 mb-4">
                <br />
                <h2 className="text-black mb-1">Tree Structure <span className="text-primary fs-5"></span></h2>

              </div>
            </div>

            <div className="col-12">
              <div
                className="db-profile-card p-4 position-relative overflow-hidden mb-5"
                style={{
                  minHeight: "75vh"
                }}
              >

                {/* Controls Overlay */}
                <div className="position-absolute top-0 end-0 p-4 z-3 d-flex gap-2">
                  <button className="btn btn-outline-primary btn-sm d-flex align-items-center gap-2" onClick={handleRetry} style={{ borderRadius: '8px', fontWeight: 'bold' }}>
                    <RefreshCw size={14} /> Refresh
                  </button>
                  <div className="btn-group" style={{ boxShadow: '0 4px 10px rgba(0,0,0,0.05)', borderRadius: '8px' }}>
                    <button className="btn btn-light btn-sm border" onClick={() => setScale((s) => Math.max(0.4, s - 0.1))}><Minus size={14} /></button>
                    <span className="btn btn-light btn-sm border-top border-bottom disabled text-dark fw-bold" style={{ width: "60px", background: '#f8fafc' }}>{Math.round(scale * 100)}%</span>
                    <button className="btn btn-light btn-sm border" onClick={() => setScale((s) => Math.min(2, s + 0.1))}><Plus size={14} /></button>
                  </div>
                </div>

                {/* Content Area */}
                {loading ? (
                  <div className="d-flex flex-column align-items-center justify-content-center h-100" style={{ minHeight: "60vh" }}>
                    <div className="spinner-border text-primary mb-4" style={{ width: "3rem", height: "3rem" }} role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <h4 className="text-dark fw-bold mb-2">Fetching your team structure…</h4>
                    <p className="text-secondary text-center max-w-md">This may take a few seconds depending on your network and team size.</p>

                    <div className="mt-4 p-3 rounded text-center" style={{ maxWidth: "500px", fontSize: "0.9rem", background: 'rgba(0,111,227,0.05)', border: '1px solid rgba(0,111,227,0.1)' }}>
                      <p className="text-primary mb-1 fw-bold">Your team tree is loading…</p>
                      <p className="text-secondary mb-0">Please wait while we fetch and organize your team members. This view is fully responsive and optimized for fast navigation. If the data takes time to load, it will appear automatically once ready.</p>
                    </div>
                  </div>
                ) : error ? (
                  <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center" style={{ minHeight: "60vh" }}>
                    <AlertCircle size={48} className="text-danger mb-3" />
                    <h4 className="text-dark fw-bold">Unable to load team data right now.</h4>
                    <p className="text-secondary">Please refresh or try again later.</p>
                    <button className="btn btn-primary mt-3 px-4" onClick={handleRetry} style={{ borderRadius: '8px', fontWeight: 'bold' }}>Try Again</button>
                  </div>
                ) : (
                  <div
                    className="w-100 h-100 overflow-auto"
                    style={{
                      cursor: "grab",
                      padding: "40px",
                      minHeight: "70vh"
                    }}
                  >
                    <div
                      className="tree-root"
                      style={{
                        transform: `scale(${scale})`,
                        transformOrigin: "top center",
                      }}
                    >

                      {treeData.map((root, index) => (
                        <OrgChartNode
                          key={index}
                          node={root}
                          level={0}
                          onExpand={handleExpand}
                        />
                      ))}
                    </div>
                  </div>
                )}


              </div>
            </div>
          </div>
        </div>
      </section>
      <style>{`

      .tree-node {
  width: 230px;
  background: rgba(238, 242, 246, 0.7);
  border-radius: 16px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  box-shadow: 1px 15px 15px 0px rgba(191, 201, 216, 0.3), inset 0 2px 0 #ffffff;
  position: relative;
  backdrop-filter: blur(10px);
  transition: all 0.3s;
}

.node-card {
  position: relative;
  border-radius: 16px;
  background-clip: padding-box;
  transition: all 0.3s;
}

/* ACTIVE / EXPANDED */
.node-card.active .tree-node {
  border-color: #006fe3;
  box-shadow: 0 4px 15px rgba(0, 111, 227, 0.15), inset 0 2px 0 #ffffff;
}

/* Hover polish */
.node-card:hover .tree-node {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.08), inset 0 2px 0 #ffffff;
}


      .tree-root {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: max-content;
  margin: 0 auto;
}
.node-legs {
  display: flex;
  flex-direction: column;
  gap: 6px;          /* tighter spacing */
  margin-top: 8px;
}

/* Small compact box */
.leg-box {
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid rgba(0,0,0, 0.05);
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease;
}

/* Label – very small */
.leg-label {
  display: block;
  font-size: 11px;
  color: #64748b;
  font-weight: 600;
  line-height: 1.1;
}

/* Value – compact but readable */
.leg-value {
  font-size: 12px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
}

/* Subtle hover */
.leg-box:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0,0,0,0.05);
}

.node-volume {
  margin-top: 12px;
  padding: 8px 12px;
  border-radius: 999px; /* 🔥 Fully curved pill */
  text-align: center;
  background: rgba(16, 185, 129, 0.1);
  border: 1px solid rgba(16, 185, 129, 0.2);
  color: #059669;
  font-weight: 800;
  font-size: 12px;
  letter-spacing: 0.3px;
  transition: all 0.25s ease;
}

/* ✨ Hover glow (desktop only) */
.node-volume:hover {
  transform: translateY(-1px) scale(1.02);
  box-shadow: 0 4px 10px rgba(16, 185, 129, 0.15);
}

.tree-connector {
  width: 2px;
  height: 40px;
  background: #94a3b8;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .node-grid {
    grid-template-columns: 1fr;
  }

  .node-volume {
    font-size: 13px;
    
  }
}


.node-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  font-size: 11px;
}

.node-grid div {
  background: rgba(255,255,255,0.03);
  padding: 6px 8px;
  border-radius: 8px;
}

.node-grid span {
  color: #94a3b8;
}

.node-grid b {
  color: #e5e7eb;
}
.node-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.user-team {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  font-size: 11px;
  color: #64748b;
  font-weight: 600;
}

.user-team b {
  color: #006fe3;
  font-weight: 800;
}

.user-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(0, 111, 227, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #006fe3;
  font-size: 20px;
  border: 1px solid rgba(0, 111, 227, 0.2);
}

.node-name {
  font-size: 15px;
  font-weight: 800;
  color: #1a2234;
}

.node-sub {
  font-size: 11px;
  color: #64748b;
  letter-spacing: 0.5px;
  font-weight: 600;
}

        `}
      </style>
    </div>
  );
}
